import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3427c62e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=3427c62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../Com.GamerSky.App.GameTools/GamerSky.recordInquiry/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3427c62e",
  null
  
)

export default component.exports